import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useProfilePageStyle = makeStyles((theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    }
}))
